module.exports = __webpack_public_path__ + "img/project_quizhunt.7fef9c50.png";